export default __webpack_public_path__ + "c56a316e2a92809a73649b2031675317.jpeg";